import styled from 'styled-components'

export const Container = styled.div`
	position: fixed;
	inset: 0;
	z-index: 9999;
	width: 100%;
	height: 100vh;
	min-height: 100dvh;
	padding: ${({ isFullHeight }) => (isFullHeight ? '0px' : '30px')};
	display: flex;
	justify-content: center;
	align-items: ${({ isFullHeight }) => (isFullHeight ? 'flex-end' : 'center')};
	background: rgba(233, 236, 235, 0.7);
`

export const Content = styled.div`
	height: ${({ isFullHeight }) => (isFullHeight ? '92%' : 'auto')};
	width: ${({ widthDesktop }) => (widthDesktop ? widthDesktop : 'auto')};
	max-width: ${({ isFullHeight, widthDesktop }) => (isFullHeight ? 'auto' : widthDesktop || '430px')};
	position: relative;
`

export const CloseButton = styled.button`
	position: absolute;
	top: 12px;
	right: 12px;
	width: 32px;
	height: 32px;
	border: none;
	background: transparent;
	color: ${props => props.theme.colors.text.primaryText};
	font-size: 24px;
	line-height: 1;
	cursor: pointer;
	z-index: 1;
	padding: 0;
`

export const ModalContainer = styled.div`
	display: flex;
	text-align: center;
	flex-direction: column;
	padding: 20px;
	color: ${props => props.theme.colors.green};

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 100%;
		min-width: 350px;
		max-width: ${props => props.theme.sizes.breakPoints.tiny};
	}
`

export const ActionContainer = styled.div`
	margin-top: 30px;
	width: 100%;

	> button:first-child {
		margin-bottom: 10px;
	}

	@media (min-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: flex;
		width: 370px;
		margin-left: auto;
		margin-right: auto;
	}
`

export const ComponentContainer = styled.div`
	display: flex;
	text-align: center;
	flex-direction: column;
	align-items: ${({ $alignItems = 'flex-end' }) => $alignItems};
	justify-content: flex-start;
	padding: ${({ $padding = '24px 20px 50px 20px' }) => $padding};
	font-size: 24px;
	background: ${props => props.theme.colors.brand.white};
	width: 100%;
	border-radius: 25px;
	gap: 14px;
	height: ${({ $height, isFullHeight }) => $height || (isFullHeight ? '100%' : 'auto')};
	min-height: ${({ $minHeight = 'auto' }) => $minHeight};
	@media (min-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: flex;
		padding: ${({ $paddingDesktop, $padding = '24px 20px 50px 20px' }) =>
			$paddingDesktop || $padding};
		text-align: center;
		flex-direction: column;
		align-items: ${({ $alignItems = 'flex-end' }) => $alignItems};
	}
`

export const ButtonsContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	max-width: ${({ maxWidth }) => maxWidth || '600px'};
`
